import React, { Fragment } from "react";
import clsx from "clsx";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import TwitterIcon from '@material-ui/icons/Twitter';
import logo from "assets/images/logo.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import useFilter from "Hooks/useFilter";
import { withRouter } from "react-router";
import { message } from "constants/message";
import dayjs from "dayjs";
dayjs.locale("ja");

import MediaSideMenu from "../../Components/MediaSideMenu";
import {
  Button,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@material-ui/core";
import Copyright from "../../Components/Copyright";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import {useQueryString} from "Hooks/useQueryString";

import Logout from "../../Components/Logout";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import Link from "@material-ui/core/Link";

import Badge from '@material-ui/core/Badge';
import Modal from '@material-ui/core/Modal';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: "0px",
  },
  userName: {
    display: "inherit",
    alignItems: "center",
    fontSize: "15px",
    padding: "8px",
  },
  menuIcon: {
    display: "inherit",
    alignItems: "center",
    fontSize: "15px",
  },
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    minWidth: "160px",
  },
  logoImage: {
    width: "140px" ,
    cursor: "pointer",
  },
  infomationUrl: {
    marginRight: "8px",
    fontSize: "20px",
    color: "#fff",
  },
  drawerPaper: {
    position: "fixed",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflow: "hidden",
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
  container: {
    [theme.breakpoints.down('xl')]: {
      // Update 2023.03.31
      //maxWidth: "1285px",
      maxWidth: "1480px",
    },
    [theme.breakpoints.up('xl')]: {
      // Update 2023.03.31
      //maxWidth: "1480px",
      maxWidth: "1600px",
    },
    paddingLeft: drawerWidth,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  containerShift: {
    paddingLeft: theme.spacing(7),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  groupName: {
    fontWeight: "bold",
    fontSize: "18px",
  },
  loading: {
    position: "fixed",
    zIndex: 111111,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#000",
    opacity: 0.3,
  },
  menuList: {
    marginTop: "64px",
    height: "90%",
    overflowX: "hidden",
  },
  menuListClose: {
    height: "90%",
    overflow: "hidden",
  },
  menuLink: {
    "&:hover": {
      textDecorationLine: "none",
    },
  },
  mediaTab: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    cursor: "pointer",
  },
  hideMenu: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    cursor: "pointer",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  nthOfTypeOddUnreadRow: {
    backgroundColor: "#dbdb9a",
  },
  nthOfTypeEvenUnreadRow: {
    backgroundColor: "#ffff99",
  },
  tableBody: {
    display: "block",
    overflowY: "scroll",
  },
  tableContent: {
    width: "100%",
    maxWidth: "1180px",
  },
  table: {
    position: 'fixed',
    top: "65px",
    left: drawerWidth,
    maxWidth: `calc(100% - ${drawerWidth + 180}px)`,
    backgroundColor: "#FFF",
  },
  validFrom: {
    width: "108px",
  },
}));

const LinkedListSubheader = withStyles(() => ({
  sticky: {
    cursor: "pointer",
  },
}))(ListSubheader);
const ActiveListSubheader = withStyles((theme) => ({
  sticky: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}))(ListSubheader);

function Layout(props) {
  const filter = useFilter();
  const { state } = useAuth();
  const auth = useAuth();
  const { request } = useApi();
  const api = useApi();
  const messages = message();
  const queryParams = useQueryString();

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [logoutOpen, setLogoutOpen] = React.useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = React.useState(false);
  const [userName, setUserName] = React.useState("");
  const [masterMode, setMasterMode] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [numbOfUnreadText, setNumbOfUnreadText] = React.useState(0);
  const [numbOfUnreadLink, setNumbOfUnreadLink] = React.useState(0);
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    // リンクなしお知らせ既読登録＆未読カウント数変更処理
    auth.state.informations.forEach((row) => registRead(row));
    setModalOpen(false);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogoutOpen = () => {
    setAnchorEl(null);
    setLogoutOpen(true);
  };

  const handleLogoutClose = () => {
    setLogoutOpen(false);
  };

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || token === null) {
      props.history.push("/?status=401");
      return;
    }

    // 他メディアが有効でない場合はダッシュボード画面に戻す
    const user = JSON.parse(localStorage.getItem("user"));

    // オプションが無いまたはメディアがfalseの場合ダッシュボード画面へ
    if (!user.options || !user.options.media) {
      props.history.push("/dashboard");
      return;
    }

    setUserName(user.name);

    auth.login({
      user: user,
      token: token,
    });

    // 顧客調査画面からの場合、ログアウトボタンを非表示
    if (localStorage.getItem("customerScreenMode")) {
      setMasterMode(true)
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token || auth.state.activeMediaGroup !== 0) {
      return;
    }

    request({
      method: "GET",
      url: "data/:account_id/media/groups",
    }).then((data) => {
      auth.setMediaGroups(data.data);
    });

    request({
      method: "POST",
      url: "config/:account_id/account",
      data: {
        "attrs": [
          "max_users",
        ]
      },
    }).then((data) => {
      auth.dispatch({
        type: "set",
        payload: {
          maxUsers: data.data.max_users,
        },
      });
    });

    updateInfo();
  }, [auth.state.token]);

  const updateInfo = async () => {
    // token がセットされていないときはリクエストしない（token がないとレスポンス 401 になりログイン画面に遷移してしまう）
    if (!auth.state.token) {
      return;
    }
    // お知らせを取得してセット
    await request({
      method: "GET",
      url: "information?display=dashboard",
    }).then(result => {
      if (result) {
        auth.setInformations(result.data);
        // 90日以上お知らせ一覧に表示されていないお知らせを LocalStrage から削除
        deleteInformations();
        // 未読お知らせ数設定
        setNumbOfUnread(result.data);
      }
    });
    // ヘッダ告知を取得してセット
    await request({
      method: "GET",
      url: "information_url",
    }).then((data) => {
      if (data.data) {
        auth.setInformationUrl(data.data);
      }
    });
    // ヘッダ告知、お知らせ API リクエスト日から一定期間経っていたら再リクエストするので持っておく
    localStorage.setItem("infoReqDate", Date.now());
  };

  // 90日以上お知らせ一覧に表示されていないお知らせを LocalStrage から削除
  const deleteInformations = () => {
    // 開発環境は1分（テスト用）、
    // 商用環境は90日で、配信されなくなったお知らせ ID を削除する
    const period = parseFloat(process.env.REACT_APP_DELETE_INFORMATION);
    let knownInfomations = getKnownInfomations();
    if (knownInfomations?.link) {
      const infoIds = Object.keys(knownInfomations.link);
      infoIds.forEach((id) => {
        if ((Date.now() - parseFloat(knownInfomations.link[id])) > period) {
          delete knownInfomations.link[id];
        }
      });
    }
    if (knownInfomations?.text) {
      const infoIds = Object.keys(knownInfomations.text);
      infoIds.forEach((id) => {
        if ((Date.now() - parseFloat(knownInfomations.text[id])) > period) {
          delete knownInfomations.text[id];
        }
      });
    }
    localStorage.setItem("informations", JSON.stringify(knownInfomations));
  }

  // 未読お知らせ数設定
  const setNumbOfUnread = (infomations) => {
    setNumbOfUnreadLink(0);
    setNumbOfUnreadText(0);
    let knownInfomations = getKnownInfomations();
    infomations.map((info) => {
      if (info.url) {
        if (knownInfomations?.link?.[info.id]) {
          knownInfomations.link[info.id] = Date.now();
        }
        else {
          setNumbOfUnreadLink((prev) => prev + 1);
        }
      }
      else {
        if (knownInfomations?.text?.[info.id]) {
          knownInfomations.text[info.id] = Date.now();
        }
        else {
          setNumbOfUnreadText((prev) => prev + 1);
        }
      }
    });
    localStorage.setItem("informations", JSON.stringify(knownInfomations));
  };

  // URL またはアクティブグループが変わったときに実行
  React.useEffect(() => {
    // グループID同期
    if (queryParams.size > 0) {
      if (queryParams.has("activeMediaGroup")) {
        const activeMediaGroup = parseInt(queryParams.get("activeMediaGroup"), 10);
        if (auth.state.activeMediaGroup !== activeMediaGroup) {
          if (auth.state.mediaGroups.filter(group => group.id === activeMediaGroup).length) {
            auth.dispatch({
              type: "set",
              payload: {
                activeMediaGroup: activeMediaGroup,
              },
            });
          }
        }
      }
    }

    // ヘッダ告知・お知らせ情報をアップデートすべきならする
    if (shouldTheInformationBeUpdated()) {
      updateInfo();
    }
    // 画面更新後に未読お知らせ数を再描画するため再設定
    else if (auth.state.informations.length > 0) {
      setNumbOfUnread(auth.state.informations);
    }
  }, [window.location.pathname, window.location.search, window.location.hash, auth.state.activeMediaGroup]);

  // ヘッダ告知・お知らせ情報をアップデートすべきか判定する
  const shouldTheInformationBeUpdated = () => {
    // 開発環境は1分（テスト用）、
    // 商用環境は10分ごとに最新を取得する
    const period = parseFloat(process.env.REACT_APP_RELOAD_PERIOD);
    if (localStorage.getItem("infoReqDate")) {
      const lastUpdateDate = parseFloat(localStorage.getItem("infoReqDate"));
      if ( (Date.now() - lastUpdateDate) > period ) {
        return true;
      }
    }
    return false;
  }

  const handleClickLogo = () => {
    props.history.push("/media/dashboard?activeMediaGroup=" + state.activeMediaGroup);
  };

  const handleClickGroup = (groupId) => {
    props.history.push("/media/dashboard?activeMediaGroup=" + groupId);
    auth.dispatch({
      type: "set",
      payload: {
        activeMediaGroup: groupId,
      },
    });
  };

  const handleClickBazz = () => {
    // 期間をリセットして遷移
    filter.setFilteredDateFrom(dayjs().subtract(1, "month"));
    filter.setFilteredDateTo(dayjs());
    props.history.push("/dashboard?activeMediaGroup=" + state.activeMediaGroup);
  };

  // マニュアル取得処理
  const handleManual = () => {
    setAnchorEl(null);
    request({
      method: "GET",
      url: `manual`,
      responseType: "arraybuffer",
      headers: { Accept: "application/pdf" },
    }).then((data) => {
      const file = new Blob([data], {
        type: "application/pdf",
      });
      // ファイルダウンロード
      saveAs(file, `BuzzFinderユーザマニュアル.pdf`);
    })
    .catch((error) => {
      console.log(error);
      // エラーダイアログを表示
      setIsShowErrorModal(true)
    });
  };

  // ヘッダのリンクをメニュー化してまとめる (https://git.comswork.com/twitter/bf4/bf4-frontend/-/issues/193「【要望】ログイン後のヘッダーの変更」)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickConfig = () => {
    setAnchorEl(null);
    props.history.push("/media/config");
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const knownInfomations = getKnownInfomations();
    // 未読お知らせかどうか
    const isUnread = (!knownInfomations?.link?.[row.id] && !knownInfomations?.text?.[row.id]);

    return (
      <React.Fragment>
        <TableRow className={  ( isNthOfTypeOdd &&  isUnread) ? classes.nthOfTypeOddUnreadRow
                            :  ( isNthOfTypeOdd && !isUnread) ? classes.nthOfTypeOddRow
                            :  (!isNthOfTypeOdd &&  isUnread) ? classes.nthOfTypeEvenUnreadRow
                                                              : null
        }>
          <TableCell className={classes.validFrom}>{dayjs(row.valid_from).format("YYYY/MM/DD")}</TableCell>
          <TableCell className={classes.tableContent}>
            {row.url ? (
              <a href={row.url} target="_blank" onClick={(e) => handleInfoLinkClick(e, row)}>{row.content}</a>
            ) : (
              row.content
            )}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const handleInfoLinkClick = (e, row) => {
    e.preventDefault();
    // リンク付きお知らせ既読登録＆未読カウント数変更処理
    registRead(row, 'click');
    handleModalClose();
    window.open(row.url, '_blank');
  };

  const registRead = (row, ...arg) => {
    let knownInfomations = getKnownInfomations();
    if (row.url) {
      if (!knownInfomations?.link?.[row.id] && arg.length > 0 && arg[0] === 'click') {
        setNumbOfUnreadLink((prev) => prev - 1);
        knownInfomations.link = {...knownInfomations?.link, [row.id]: Date.now()};
      }
      else if (knownInfomations?.link?.[row.id]) {
        knownInfomations.link = {...knownInfomations?.link, [row.id]: Date.now()};
      }
    }
    else {
      if (!knownInfomations?.text?.[row.id]) {
        setNumbOfUnreadText((prev) => prev - 1);
      }
      knownInfomations.text = {...knownInfomations?.text, [row.id]: Date.now()};
    }
    localStorage.setItem("informations", JSON.stringify(knownInfomations));
  }

  // 既読お知らせIDを取得する
  const getKnownInfomations = () => {
    let knownInfomations = {};
    if (localStorage.getItem("informations")) {
      knownInfomations = JSON.parse(localStorage.getItem("informations"));
    }
    return knownInfomations;
  }

  return (
    <div className={classes.root}>
      {api.state.isFetch && (
        <div className={classes.loading}>
          <CircularProgress color="secondary" />
        </div>
      )}
      <Logout logoutOpen={logoutOpen} handleLogoutClose={handleLogoutClose} />
      <CssBaseline />
      <AppBar
        position="absolute"
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
            onClick={handleClickLogo}
          >
            <img src={logo} className={classes.logoImage}/>
          </Typography>

          <Typography
            component="h2"
            variant="h6"
            color="inherit"
            noWrap
          >
          {(auth.state.informationUrl.url && auth.state.informationUrl.title) && (
            <a
              href={auth.state.informationUrl.url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.infomationUrl}
            >
              {auth.state.informationUrl.title}
            </a>
          )}
          </Typography>
          {/* お知らせがあったら表示 (https://git.comswork.com/twitter/bf4/bf4-frontend/-/issues/198「【改修】ヘッダ告知部分のレイアウトをヘッダ告知 + お知らせ通知に変更」) */}
          {auth.state.informations.length > 0 && (
          <Fragment>
            <Button color="inherit" onClick={handleModalOpen}>
              <Badge badgeContent={numbOfUnreadText + numbOfUnreadLink} max={9} color="error"> {/* ← 赤地白抜き文字になる色設定 */}
                <Typography
                  color="inherit"
                  noWrap
                  className={classes.menuIcon}
                >
                  お知らせがあります
                </Typography>
              </Badge>
            </Button>
            <Modal
              open={modalOpen}
              onClose={handleModalClose}
            >
              <TableContainer component={Paper}>
                <Table className={classes.table}>
                  <TableBody className={classes.tableBody} style={{height: auth.state.informations.length * 53.016, maxHeight: "50vh"}}>
                    {auth.state.informations.map(
                      function (row, index) {
                        return <Row key={row.id} index={index+1} row={row} />
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Modal>
          </Fragment>
          )}
          <Typography
            color="inherit"
            noWrap
            className={classes.userName}
            style={{minWidth: userName.length * 15 + 40}}
          >
            <AccountCircleIcon /> {userName}
          </Typography>
          {/* ヘッダのリンクをメニュー化してまとめる (https://git.comswork.com/twitter/bf4/bf4-frontend/-/issues/193「【要望】ログイン後のヘッダーの変更」) */}
          <Button color="inherit" onClick={handleClick}>
            <Typography
              color="inherit"
              noWrap
              className={classes.menuIcon}
            >
              <MenuIcon />
            </Typography>
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClickConfig}>管理メニュー</MenuItem>
            <MenuItem onClick={handleManual}>マニュアル</MenuItem>
            <MenuItem onClick={handleClose}>
              <Link
                color="inherit"
                className={classes.menuLink}
                href="https://www.nttcoms.com/service/social/buzz_finder/archive/"
                target="_blank"
              >
                お役立ちコンテンツ
              </Link>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <Link
                color="inherit"
                className={classes.menuLink}
                href="https://www.nttcoms.com/service/social/buzz_finder/support_form/"
                target="_blank"
              >
                お問い合わせ
              </Link>
            </MenuItem>
            {!masterMode && (<MenuItem onClick={handleLogoutOpen}>ログアウト</MenuItem>)}
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <List
          id="menuList"
          className={open ? classes.menuList : classes.menuListClose}
        >
          {state.mediaGroups.length > 0 && (
            state.mediaGroups.map((mediaGroup) => {
              return (
                <>
                  {state.activeMediaGroup === mediaGroup.id ? (
                    <Tooltip title={mediaGroup.name}>
                      <ActiveListSubheader className={classes.groupName} key={mediaGroup.id}>
                        {mediaGroup.name}
                      </ActiveListSubheader>
                    </Tooltip>
                  ) : (
                    <LinkedListSubheader
                      className={classes.groupName}
                      key={mediaGroup.id}
                      onClick={() => handleClickGroup(mediaGroup.id)}
                      selected={state.activeMediaGroup === mediaGroup.id}
                    >
                      {mediaGroup.name}
                    </LinkedListSubheader>
                  )}

                  {state.activeMediaGroup === mediaGroup.id && (
                    <MediaSideMenu />
                  )}
                </>
              );
            })
          )}
        </List>
        {JSON.parse(localStorage.getItem("user")) &&
          JSON.parse(localStorage.getItem("user")).contract_type != "ruby" && (
          <div
            className={classes.mediaTab}
            onClick={handleClickBazz}
          >
            <ListItemIcon>
              <TwitterIcon />
            </ListItemIcon>
            <ListItemText primary="Buzz Finder" />
          </div>
        )}
        <div
          className={classes.hideMenu}
          onClick={open ? handleDrawerClose : handleDrawerOpen}
        >
          <ListItemIcon>
            {open ? (<ChevronLeftIcon />) : (<ChevronRightIcon />)}
          </ListItemIcon>
          <ListItemText primary="メニューを隠す" />
        </div>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container className={
          clsx(classes.container, !open && classes.containerShift)
        }>
          {props.content}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
      <Dialog open={isShowErrorModal}
        onClose={() => setIsShowErrorModal(false)}
      >
        <DialogContent>
          <DialogContentText>
            {messages.errorMsg.getManualErr}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setIsShowErrorModal(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withRouter(Layout);
